import React from "react";
import "./AuthFooter.css";

const AuthFooter = () => {
  return (
    <footer className="auth-footer">
      <p>Acorn Publishing Company © 2025. All rights reserved.</p>
    </footer>
  );
};

export default AuthFooter;
